import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type RoomUpdaterProps = {
    control: Control<ScheduleActionFormData>;
    resources: Array<any>;
    isUpdatingRoom: boolean;
    onUpdateRoom: () => void;
    onCancel: () => void;
};

export const RoomUpdater = ({ control, resources, isUpdatingRoom, onUpdateRoom, onCancel }: RoomUpdaterProps) => {
    const targetRoomId = useWatch({ control, name: "targetRoomId" });

    return (
        <Box p={2}>
            <Controller
                name="targetRoomId"
                control={control}
                render={({ field }) => (
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="room-update-select-label">Sala</InputLabel>
                        <Select
                            labelId="room-update-select-label"
                            label="Sala"
                            value={field.value || ""}
                            name={field.name}
                            onBlur={field.onBlur}
                            onChange={(e) => field.onChange(e.target.value as number)}
                            inputRef={field.ref}
                        >
                            {resources?.map((resource: any) => (
                                <MenuItem key={resource.id} value={resource.id}>
                                    {resource.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            />

            <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={onUpdateRoom}
                disabled={isUpdatingRoom || !targetRoomId}
                sx={{ mb: 1 }}
            >
                {isUpdatingRoom ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Atualizar Sala
            </Button>
            <Button fullWidth color="secondary" size="small" onClick={onCancel}>
                Cancelar
            </Button>
        </Box>
    );
};


